module.exports = __webpack_public_path__ + "img/Group 97704.c64ec956.png";